<template>
    <section>
        <div class="modal-card" style="width: 50vw; height: 70vh">
            <header class="modal-card-head">
                <p class="modal-card-title">Product Discount Exports</p>
                <button
                    type="button"
                    class="delete"
                    @click="$emit('close')"/>
            </header>
            <section class="modal-card-body">
                <div class="is-flex is-justify-content-space-between is-align-items-center">
                    <div style="margin-left: auto">
                        <b-button
                            icon-left="autorenew"
                            @click="fetchFiles">
                        </b-button>
                    </div>
                </div>
                <b-table :data="files"
                         :total="files.length"
                         :per-page="7"
                         :loading="tableShouldLoad"
                         paginated
                         striped bordered>
                    <b-table-column width="50%" label="Retailer" v-slot="props">
                        {{ props.row.retailer.name }}
                    </b-table-column>
                    <b-table-column width="50%" label="File name" v-slot="props">
                        {{ props.row.filename }}
                    </b-table-column>
                    <b-table-column width="150" label="Data di creazione" v-slot="props" centered sortable>
                        {{ getHumanDate(props.row.created_at) }}
                    </b-table-column>
                    <b-table-column width="100" label="Download" v-slot="props" centered>
                        <p v-if="props.row.in_progress">In Progress</p>
                        <a v-else target="_blank" :href="props.row.url">Download</a>
                    </b-table-column>
                </b-table>
            </section>
        </div>
    </section>
</template>

<script>
import moment from "moment";

export default {
    data() {
        return {
            tableShouldLoad: false,
            files: []
        }
    },
    mounted() {
        this.fetchFiles();
    },
    methods: {
        fetchFiles() {
            this.tableShouldLoad = true;
            axios.get('/discount/products/export/files')
                .then(response => {
                    this.files = response.data;
                })
                .finally(() => {
                    this.tableShouldLoad = false;
                })
        },
        getHumanDate(date) {
            return moment(date).format('DD MMM YYYY HH:mm');
        }
    }
}
</script>

